import { nextFrame } from "../../shared/event/next-frame";
import { hasMetrics } from "@escapio/shared/state/client-settings";
import { data } from "@escapio/shared/state/payload";

const DEFAULT_URL = new URL(data.uris.metric);

/**
 * Send a new event metric value
 *
 * @param {string} metric
 * @param {number} value
 * @param {URL} url
 * @return {void}
 */
export async function send(metric, value, url = DEFAULT_URL) {
	if (!hasMetrics) return;

	await nextFrame();

	url.searchParams.append("e", metric);
	url.searchParams.append("v", value);

	return fetch(url, { method: "get", credentials: "include" });
}

const previousMetrics = new Set();
export async function sendOncePerKey(key, metric, value, url) {
	if (previousMetrics.has(key)) {
		return;
	}
	previousMetrics.add(key);
	send(metric, value, url);
}
